import { Button } from 'ht-styleguide';
import React from 'react';
import { IButton, ILink } from 'ht-styleguide/build/Button/Button.types';

const ButtonWrapper = (props: React.JSX.IntrinsicAttributes & (IButton | ILink)) => (
  <div className={props.className}>
    <Button {...props}>{props.children}</Button>
  </div>
);

export default ButtonWrapper;
